/* eslint-disable */
import React, { useEffect, useState } from 'react';
import {
  DataGridPremium,
  GridToolbarContainer,
  GridToolbar,
  GridToolbarExport,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  useGridApiRef,
  useKeepGroupedColumnsHidden,
  GridEvents,
} from '@mui/x-data-grid-premium';
import base64 from 'base-64';
import { filter } from 'lodash';
import {
  Button,
  Link,
  Backdrop,
  CircularProgress,
  Typography,
  Modal,
  Box,
  TextField,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import getdealerid from '../../assets/data/exdealers';

function sortBy(key, data) {
  return data.sort((a, b) => {
    var x = parseInt(a[key]);
    var y = parseInt(b[key]);
    return x > y ? -1 : x < y ? 1 : 0;
  });
}

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const DealerWarrantyRegistrationTable = (id) => {
  const [tableData, setTableData] = useState([]);
  const [rows, setRows] = useState(tableData);
  const [pageSize, setPageSize] = useState(25);
  const [deletedRows, setDeletedRows] = useState([]);
  const [open, setOpen] = React.useState(false);
  const apiRef = useGridApiRef();
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [boatNumber, setBoatNumber] = useState('');
  const [boatNumber2, setBoatNumber2] = useState('');
  const [dealerId, setDealerId] = useState('');
  const navigate = useNavigate();
  const [filt, setFilt] = useState({
    items: [],
  });

  let baddealer = false;

  useEffect(() => {
    async function fetchData() {
      const res = await getdealerid(id.id);
      setDealerId(res);
    }
    fetchData();
  }, [id]);
  if (!dealerId) {
    baddealer = false;
  }

  function CustomToolbar({ onOpenModal }) {
    return (
      <GridToolbarContainer>
        <GridToolbar />
        <Button
          variant="outlined"
          color="primary"
          sx={{ marginBottom: 3, color: '#ffffff' }}
          onClick={() =>
            setFilt({
              items: [{ field: 'regdate', operator: 'isEmpty' }],
              logicOperator: 'and',
              quickFilterLocicOperator: 'and',
            })
          }
        >
          View Unregistered Boats
        </Button>
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleOpenModal2 = () => setOpenModal2(true);
  const handleCloseModal2 = () => setOpenModal2(false);

  const handleBoatNumberChange = (event) => {
    const value = event.target.value;
    // Use a regular expression to allow only numbers
    const onlyNums = value.replace(/[^0-9]/g, '');
    if (onlyNums.length <= 6) {
      setBoatNumber(onlyNums);
    }
  };
  const handleBoatNumberChange2 = (event) => {
    setBoatNumber2(event.target.value);
  };
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  useEffect(() => {
    setRows(tableData);
  }, [tableData]);

  useEffect(() => {
    if (!dealerId) return;
    if (!baddealer) {
      handleOpen();
      fetch(
        `${
          process.env.REACT_APP_BACKEND_SERVER
        }/dealerportal/warrantyregistration/${encodeURIComponent(dealerId)}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        }
      )
        .then((data) => data.json())
        .then((jsonData) => {
          return jsonData;
        })
        .then((data) => {
          handleClose();
          setTableData(data);
        })
        .catch((error) => {
          // handle the error here
        });
    }
  }, [dealerId]);

  const searchBoatNumber = () => {
    fetch(
      `${process.env.REACT_APP_BACKEND_SERVER}/dealerportal/completewarrantyregistration/${boatNumber}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.length > 0) {
          handleCloseModal();
          navigate(`/tools/dealerclaimform/${id.id}/${boatNumber}/stock`);
        } else {
          handleCloseModal();
          navigate(`/tools/dealerclaimform/${id.id}/${boatNumber}/notstock`);
        }
      })
      .catch((error) => {
        console.error('Error searching boat number:', error);
      });
  };

  const searchBoatNumber2 = () => {
    fetch(
      `${process.env.REACT_APP_BACKEND_SERVER}/dealerportal/completewarrantyregistration/${boatNumber2}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.length > 0) {
          handleCloseModal2();
          navigate(`/tools/viewregistration/${boatNumber2}`);
        } else {
          handleCloseModal2();
          alert('Boat number not registered.');
        }
      })
      .catch((error) => {
        console.error('Error searching boat number:', error);
      });
  };

  const columns = [
    { field: 'OrderHed_OrderNum', headerName: 'Boat #', flex: 1.5 },
    {
      field: 'Calculated_ShipDate',
      headerName: 'Ship Date',
      flex: 1.5,
      type: 'date',
      valueGetter: (params) => {
        return new Date(params.row.Calculated_ShipDate);
      },
    },
    { field: 'OrderDtl_LineDesc', headerName: 'Description', flex: 2.5 },
    {
      field: 'done_button',
      headerName: 'Registration',
      flex: 1,
      renderCell: (params) => {
        if (params.row.regdate == '') {
          return (
            <Link href={`/tools/dealerregistrationform/${id.id}/${params.row.OrderHed_OrderNum}`}>
              <Button variant="contained" color="primary" size="small">
                Register
              </Button>
            </Link>
          );
        } else {
          return (
            <Link href={`/tools/viewregistration/${params.row.OrderHed_OrderNum}`}>
              <Button variant="contained" color="success" size="small">
                View Registration
              </Button>
            </Link>
          );
        }
      },
    },
    {
      field: 'claim_button',
      headerName: 'Warranty Claim',
      flex: 1,
      renderCell: (params) => {
        if (params.row.regdate === '') {
          // If registration is not done, go to /stock
          return (
            <Link
              href={`/tools/dealerclaimform/${id.id}/${params.row.OrderHed_OrderNum}/stock`}
              style={{ textDecoration: 'none' }}
            >
              <Button variant="contained" color="secondary" size="small">
                Warranty Claim
              </Button>
            </Link>
          );
        } else {
          // If registration is done, go to /nostock
          return (
            <Link
              href={`/tools/dealerclaimform/${id.id}/${params.row.OrderHed_OrderNum}/notstock`}
              style={{ textDecoration: 'none' }}
            >
              <Button variant="contained" color="secondary" size="small">
                Warranty Claim
              </Button>
            </Link>
          );
        }
      },
    },
    {
      field: 'regdate',
      headerName: 'Registration date',
      flex: 1.5,
    },
  ];
  const initialState = useKeepGroupedColumnsHidden({
    apiRef,
    initialState: {
      sorting: {
        sortModel: [{ field: 'Calculated_ShipDate', sort: 'desc' }],
      },
      columns: {
        columnVisibilityModel: {
          regdate: false,
        },
      },
    },
  });
  return (
    <div style={{ height: 1000, width: '100%' }}>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="secondary" />
        <Typography variant="h3" color="secondary" sx={{ ml: 2 }}>
          Loading...
        </Typography>
      </Backdrop>
      <Grid alignItems="left" sx={{ mb: 2 }} container>
        <Typography variant="h5">
          If you need to enter a claim for a boat not found below click here (please enter a 7
          before boat number example 762000 for boats MY2024 and newer)
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenModal}
          style={{ marginLeft: '10px' }}
        >
          Custom Warranty Claim
        </Button>
      </Grid>
      <Grid alignItems="left" sx={{ mb: 2 }} container>
        <Typography variant="h5">
          To lookup a registration for a boat not found below click here.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenModal2}
          style={{ marginLeft: '10px' }}
        >
          Warranty Registration Lookup
        </Button>
      </Grid>

      <DataGridPremium
        rows={rows}
        columns={columns}
        components={{
          Toolbar: CustomToolbar,
        }}
        getRowId={(row) => row.OrderHed_OrderNum}
        pageSize={pageSize}
        rowsPerPageOptions={[25, 50, 100]}
        pagination
        filterModel={filt}
        onFilterModelChange={(newFilterModel) => {
          // Validate filter items to ensure they have required fields
          const validatedModel = {
            ...newFilterModel,
            items: newFilterModel.items.filter((item) => item && item.field && item.operator),
          };
          setFilt(validatedModel);
        }}
        initialState={initialState}
        apiRef={apiRef}
        onPageSizeChange={(params) => {
          handlePageSizeChange(params.pageSize);
        }}
      />
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...modalStyle,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              marginTop: 2,
              marginBottom: 2,
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            Please enter a 7 before boat number. For example: If your DVN is "DVN62000I324" then
            your boat number is "762000".
          </Typography>
          <TextField
            id="boatNumber"
            label="Boat #"
            variant="outlined"
            fullWidth
            value={boatNumber}
            onChange={handleBoatNumberChange}
            inputProps={{
              maxLength: 6,
              inputMode: 'numeric',
              pattern: '[0-9]*',
              title: 'Enter a 6-digit boat number',
            }}
          />
          <Button onClick={searchBoatNumber} style={{ marginTop: '10px' }} variant="contained">
            Enter Warranty Claim
          </Button>
        </Box>
      </Modal>
      <Modal
        open={openModal2}
        onClose={handleCloseModal2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...modalStyle,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              marginTop: 2,
              marginBottom: 2,
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            Please enter a 7 before boat number. For example: If your DVN is "DVN62000I324" then
            your boat number is "762000".
          </Typography>
          <TextField
            id="boatNumber"
            label="Boat #"
            variant="outlined"
            fullWidth
            value={boatNumber2}
            onChange={handleBoatNumberChange2}
            inputProps={{
              maxLength: 6,
              inputMode: 'numeric',
              pattern: '[0-9]*',
            }}
          />
          <Button onClick={searchBoatNumber2} style={{ marginTop: '10px' }} variant="contained">
            Lookup Registration
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default DealerWarrantyRegistrationTable;
